import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface UpgradeModalProps {
  isOpen: boolean
  onClose: () => void
  message: string
  type: 'timetable' | 'exam'
}

export const UpgradeModal = React.memo<UpgradeModalProps>(({
  isOpen,
  onClose,
  message,
  type,
}) => {
  const { t } = useTranslation('common')

  // Debug log - only when isOpen changes
  React.useEffect(() => {
    if (isOpen) {
  // console.log🟢 [UpgradeModal] Opened - message:', message, 'type:', type)
    }
  }, [isOpen, message, type])

  const handleContactUs = () => {
    // Redirect to contact page
    window.location.href = '/contact'
    onClose()
  }

  // Get the type translation
  const typeText = type === 'timetable' ? t('upgradeModal.timetables') : t('upgradeModal.examSchedules')

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md w-[95vw] md:w-full">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            {t('upgradeModal.title')}
          </DialogTitle>
          <DialogDescription>
            {t('upgradeModal.description', { type: typeText })}
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
            <p className="text-sm text-amber-800">
              {t('upgradeModal.message')}
            </p>
          </div>
          <p className="text-sm text-muted-foreground mt-4">
            {t('upgradeModal.footerText', { type: typeText })}
          </p>
        </div>

        <DialogFooter>
          <Button onClick={handleContactUs} className="w-full">
            {t('contactUs.title')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
})

UpgradeModal.displayName = 'UpgradeModal'




